import './index.css'

const BlogList = props => {
  const {eachList} = props
  const {title, publishedDate, description} = eachList
  return (
    <li className="list-container">
      <div className="title-container">
        <h1 className="list-head">{title}</h1>
        <p className="list-date">{publishedDate}</p>
      </div>
      <p className="list-para">{description}</p>
      <hr className="hr-line" />
    </li>
  )
}

export default BlogList
